import { Ng1StateDeclaration, StateProvider } from "@uirouter/angularjs";
import { vsComponentName } from "./component";

export function addTimelineRoutes($stateProvider: StateProvider, name: string) {
  $stateProvider.state(name, timelineState());
}

export function timelineState(): Ng1StateDeclaration {
  return {
    url: "/timeline",
    component: vsComponentName,
  };
}
